export default "__VITE_ASSET__Bs0wT0f5__"